import React, { useContext, useState } from 'react';


import Progress from '../Progress';
import EditPersonal from './EditPersonal';
import EditAcadmic from './EditAcadmic';
import EditRegister from './EditRegister';
import EditEmployement from './EditEmployement';
import { useParams } from 'react-router-dom';
import { FormContext } from '../Provider';

export default function AdminSteps() {
    let { id } = useParams();
    console.log("Student id", id);
    const [step, setStep] = useState(0);

    const { Auth } = useContext(FormContext)

    const renderStepComponent = () => {
        switch (step) {
            case 0: return <EditPersonal step={step} setStep={setStep} id={id} />;
            case 1: return <EditAcadmic step={step} setStep={setStep} id={id} />;
            case 2: return <EditEmployement step={step} setStep={setStep} id={id} />;
            case 3: return <EditRegister step={step} setStep={setStep} id={id} />;

            default: return null;
        }
    };
    console.log("step:", step); // Debug line
    return (
        <div className='flex flex-col sm:flex-col items-start justify-center  sm:block'>
            <div className="w-full md:max-w-7xl mx-auto">
                <Progress step={step} Auth={Auth} />


            </div>
            <div className="mt-3">
                {renderStepComponent()}
            </div>
        </div>
    );
}
